export interface Horario {
  hora: string;
  ocupado?: boolean;
}

interface PropsHorarios {
  /** La API devuelve solo los libres como texto; también se aceptan con estado. */
  horarios: readonly (string | Horario)[];
  elegido: string | null;
  alElegir: (hora: string) => void;
  etiqueta?: string;
}

export function SelectorHorarios({ horarios, elegido, alElegir, etiqueta = 'Horarios disponibles' }: PropsHorarios) {
  return (
    <div className="horarios" role="group" aria-label={etiqueta}>
      {horarios.map((h) => {
        const { hora, ocupado = false } = typeof h === 'string' ? { hora: h } : h;
        const clase = hora === elegido ? 'horario horario--elegido' : ocupado ? 'horario horario--ocupado' : 'horario';
        return (
          <button
            key={hora}
            type="button"
            className={clase}
            disabled={ocupado}
            aria-pressed={hora === elegido}
            aria-label={ocupado ? `${hora}, ocupado` : undefined}
            onClick={() => { alElegir(hora); }}
          >
            {hora}
          </button>
        );
      })}
    </div>
  );
}
